import { Component, Input, OnInit } from '@angular/core';

//NON USATOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO come componente esterno

@Component({
  selector: 'app-carrozzeriemobili',
  templateUrl: './carrozzeriemobili.component.html',
  styleUrls: ['./carrozzeriemobili.component.css']
})
export class CarrozzeriemobiliComponent implements OnInit {
  @Input() itemData: any
  currentIndex=1;
  myFilterStr;
  costantValues: any[]=[];
  idTabRif: number;
  nomeTabRif: any;
  dati: any;
  constructor() { }

  ngOnInit() {
    if (this.itemData) {     
      this.idTabRif   = this.itemData[0]['idTabRif']
      this.nomeTabRif = this.itemData[0]['nomeTabRif']
      this.dati       = this.itemData[0]['dati']
      this.myFilterStr='?IdAlbo='+this.idTabRif
      this.costantValues=[{value: this.idTabRif,key:'idAlbo'}]
      //this.myFilterStr='/'+this.idTabRif
      
      /*
      this.myFilterStr[1] = '?IdAlbo='+this.idTabRif+"&tipo=O";// + this.nomeTabRif + '&IdTabella=' + this.idTabRif
      this.myFilterStr[2] = '?IdAlbo='+this.idTabRif+"&tipo=P";
      this.myFilterStr[3] = '?IdAlbo='+this.idTabRif+"&tipo=3B";
      this.myFilterStr[4] = '?IdAlbo='+this.idTabRif+"&tipo=4B";
      this.myFilterStr[5] = '?IdAlbo='+this.idTabRif+"&tipo=RMET";
      this.costantValues[1] =[{value: this.idTabRif,key:'idAlbo'},{value: 'O',key:'tipo'}]
      this.costantValues[2] =[{value: this.idTabRif,key:'idAlbo'},{value: 'P',key:'tipo'}]
      this.costantValues[3] =[{value: this.idTabRif,key:'idAlbo'},{value: '3B',key:'tipo'}]
      this.costantValues[4] =[{value: this.idTabRif,key:'idAlbo'},{value: '4B',key:'tipo'}]
      this.costantValues[5] =[{value: this.idTabRif,key:'idAlbo'},{value: 'RMET',key:'tipo'}]     
      */
    } 
  }
  public inizializza(): void {
    /**Inizializza Global Var. da funzione pubblica**/
    this.idTabRif   = this.itemData[0]['idTabRif']
    this.nomeTabRif = this.itemData[0]['nomeTabRif']
   // this.myFilterStr[0] = "?nomeTabella=" + this.nomeTabRif + "&IdTabella=" +  this.idTabRif;
    //this.uContatti.refresh();     
  }
}
